<script setup lang="ts">
import CloseButton from '../Components/CloseButton.vue'
import InformationIcon from '../Components/Icons/InformationIcon.vue'
import BaseLayout from '../Layouts/BaseLayout.vue'
</script>

<template>
    <BaseLayout>
        <div class="flex flex-1 flex-col items-center justify-center text-center text-sm space-y-4">
            <div class="rounded-full p-3 bg-primary-100">
                <InformationIcon class="size-9 text-primary-700" aria-hidden="true" />
            </div>
            <h3 class="text-xl font-semibold tracking-wide text-primary-700">
                {{ $t('Error') }}
            </h3>
            <p class="text-neutral-600">
                {{
                    $t(
                        'It’s currently not possible to make a new request, due to a technical issue.'
                    )
                }}
            </p>
        </div>
        <template #footer>
            <CloseButton />
        </template>
    </BaseLayout>
</template>
